import { NavLink } from "react-router";

import useColor from "@/utils/hooks/useColor";

import { ButtonBase, Card, Stack, Typography } from "@mui/material";
import PropTypes from "prop-types";

export default function ContactGroupCard({ contactGroup }) {
  const { color, background } = useColor(contactGroup.name);

  return (
    <Card
      sx={{
        color: color,
        background: `linear-gradient(135deg, ${background[300]} 0%, ${background[400]} 100%)`,
        display: "flex",
        flexDirection: "column",
        height: "100%",
      }}
    >
      <ButtonBase
        component={NavLink}
        to={`${contactGroup.id}`}
        sx={{
          pt: 1,
          px: 1.5,
          pb: 0,
          textAlign: "left",
          fontFamily: "revert",
          flexGrow: 1,
          alignItems: "start",
          justifyContent: "start",
          minHeight: { sx: 32, sm: 40, lg: 48 },
        }}
      >
        <Typography
          variant="h1"
          sx={{
            fontSize: "1.25rem",
            lineHeight: 1.3,
            marginBottom: 0,
          }}
        >
          {contactGroup.name}
        </Typography>
        <div style={{ flexGrow: 1 }} />
      </ButtonBase>
      <Stack
        direction="row"
        sx={{
          gap: 0.5,
          alignItems: "center",
          justifyContent: "space-between",
          p: 1.5,
          pt: 0,
          pb: 1,
        }}
      >
        <Typography sx={{ fontSize: ".75rem" }}>
          {contactGroup.unitCount ?? 0} {contactGroup.unitCount === 1 ? "contact" : "contacts"}
        </Typography>
      </Stack>
    </Card>
  );
}

ContactGroupCard.propTypes = {
  contactGroup: PropTypes.object,
};
